(() => {
  window.fabrikoneInlineZoom?.destroy();
  const controller = new AbortController();
  const signal = controller.signal;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const frameSelector = 'body.template-product media-gallery[data-zoom-on-hover] .product__modal-opener';
  let active = null;
  let pendingFrame = 0;
  let x = 0;
  let y = 0;

  function reset() {
    if (pendingFrame) cancelAnimationFrame(pendingFrame);
    pendingFrame = 0;
    if (!active) return;
    const previous = active;
    active = null;
    previous.mutations.disconnect();
    previous.resize?.disconnect();
    previous.swiper?.off('slideChangeTransitionStart activeIndexChange sliderFirstMove beforeDestroy resize', reset);
    previous.frame.removeAttribute('data-fab-inplace-zoom');
    ['--fab-zoom-x', '--fab-zoom-y'].forEach(name => previous.image.style.removeProperty(name));
  }

  function paint() {
    pendingFrame = 0;
    if (!active) return;
    const { frame, image, rect } = active;
    if (!frame.isConnected || !image.isConnected || !finePointer.matches) return reset();
    if (x < rect.left || x > rect.right || y < rect.top || y > rect.bottom) return reset();
    image.style.setProperty('--fab-zoom-x', Math.max(0, Math.min(100, (x - rect.left) / rect.width * 100)) + '%');
    image.style.setProperty('--fab-zoom-y', Math.max(0, Math.min(100, (y - rect.top) / rect.height * 100)) + '%');
    frame.setAttribute('data-fab-inplace-zoom', 'active');
  }

  function schedule(event) {
    x = event.clientX;
    y = event.clientY;
    if (!pendingFrame) pendingFrame = requestAnimationFrame(paint);
  }

  function enter(event) {
    if (!finePointer.matches || event.pointerType === 'touch' || event.buttons) return;
    if (!(event.target instanceof Element)) return;
    const frame = event.target.closest(frameSelector);
    if (!frame || frame === active?.frame || frame.querySelector('video, iframe, model-viewer')) return;
    const image = frame.querySelector(':scope > img.image-zoom-inline');
    if (!image?.complete || !image.naturalWidth) return;
    reset();
    const rect = frame.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) return;
    const gallery = frame.closest('media-gallery');
    const slide = frame.closest('.swiper-slide');
    const swiper = frame.closest('.swiper')?.swiper;
    if (slide && !slide.classList.contains('swiper-slide-active') && swiper) return;
    const mutations = new MutationObserver(records => {
      if (records.some(record => record.type === 'childList' || record.target === image ||
        (record.target instanceof Element && record.target.contains(frame)))) reset();
    });
    mutations.observe(gallery, {
      subtree: true, childList: true, attributes: true,
      attributeFilter: ['src', 'srcset', 'hidden', 'aria-hidden', 'class']
    });
    let resize;
    if ('ResizeObserver' in window) {
      resize = new ResizeObserver(entries => {
        const size = entries[0]?.contentRect;
        if (size && (Math.abs(size.width - rect.width) > 2 || Math.abs(size.height - rect.height) > 2)) reset();
      });
      resize.observe(frame);
    }
    active = { frame, image, rect, mutations, resize, swiper };
    swiper?.on('slideChangeTransitionStart activeIndexChange sliderFirstMove beforeDestroy resize', reset);
    schedule(event);
  }

  document.addEventListener('pointerover', enter, { passive: true, signal });
  document.addEventListener('pointermove', event => {
    if (!active) return;
    if (event.pointerType === 'touch' || event.buttons || !(event.target instanceof Node) || !active.frame.contains(event.target)) return reset();
    schedule(event);
  }, { passive: true, signal });
  document.addEventListener('pointerout', event => {
    if (active && (!(event.relatedTarget instanceof Node) || !active.frame.contains(event.relatedTarget))) reset();
  }, { passive: true, signal });
  ['pointerdown', 'pointercancel', 'lostpointercapture', 'dragstart', 'keydown', 'change', 'variant:update', 'variant:change', 'variant-change', 'shopify:section:unload', 'shopify:section:load'].forEach(name => {
    document.addEventListener(name, reset, { capture: true, signal });
  });
  document.addEventListener('scroll', reset, { capture: true, passive: true, signal });
  document.addEventListener('visibilitychange', reset, { signal });
  ['blur', 'pagehide', 'resize', 'orientationchange'].forEach(name => window.addEventListener(name, reset, { passive: true, signal }));
  finePointer.addEventListener('change', reset, { signal });
  window.fabrikoneInlineZoom = {
    version: '2026-09-06-inplace-1',
    destroy() { reset(); controller.abort(); }
  };
})();
